import axios from "axios";

import { ApiService } from "../../../servicios/api.service";
import LocalStorageKeys from "../../../data/localStorageKeys";

export class ComercioApi {
  static endPoint = "comerciante/comercio/";

  static get BasePath() {
    return ApiService.api + this.endPoint;
  }

  static get AuthHeader() {
    return "Bearer " + localStorage.getItem(LocalStorageKeys.tokenComercio);
  }

  static get Headers() {
    return { Authorization: this.AuthHeader };
  }

  static get Config() {
    return { headers: this.Headers };
  }

  static getMine() {
    return axios.get(this.BasePath, this.Config);
  }

  static getMinimumDiscountPercentage() {
    return axios.get(this.BasePath + "minimumDiscountPercentage", this.Config);
  }

  static update(data) {
    return axios.patch(this.BasePath, data, this.Config);
  }

  static uploadLogo(idComercio, logo) {
    return axios.post(ApiService.api + "uploads/logos/comercio/" + idComercio, logo, {
      headers: {
        Authorization: this.AuthHeader,
        "Content-Type": "multipart/form-data"
      }
    });
  }
}
